const en = {
  ACCESS_DENIED: 'Access denied',
  ACCESS_DENIED_HEADING: 'You do not have access to this digital book yet',
  ACCESS_DENIED_BUTTON_TEXT: 'Try for free for 30 days',
  ACCESS_DENIED_CONTACT_TEXT: 'Questions? Get in touch <a href="mailto:digitalt@fagbokforlaget.no">digitalt@fagbokforlaget.no</a>',
  ALL: 'All',
  LOCALE: 'en_GB',
  UI_LANG: 'English',
  DICT_LANG: 'english',
  LOGIN_BUTTON: 'Log in or sign up',
  LOGIN_WELCOME: 'Login for d-bok',
  LOGOUT: 'Logout',
  BOOK_COVER: 'Book cover',
  YOU_ARE_OFFLINE: 'No Internet connection',
  LANGUAGE : 'Language',
  CHANGE_LANGUAGE: 'Select language',
  CHOOSE_LANGUAGE: 'Switch language',
  WHILE_ONLINE_TITLE: 'Read books online or offline',
  WHILE_ONLINE: 'You can read all your books when you are online. If you want to read books offline you have to download them first. All highlights and notes that you make while offline will be synchronized when you are online.',
  OKAY: 'Okay!',
  GOT_IT: 'OK, got it!',
  MY_LIBRARY: 'My library',
  SORT_BY: 'Sort by',
  DOWNLOADED_BOOKS: 'Downloaded books',
  DOWNLOADED: 'Downloaded',
  DOWNLOADING: 'Downloading',
  RECENTLY_OPENED: 'Recently opened',
  ORDER_ASC: 'Order ascending',
  ORDER_DESC: 'Order descending',
  BOOK_DOWNLOAD: 'Download',
  BOOK_DOWNLOADING: 'Downloading',
  BOOK_READ: 'Read',
  SINCE_YOU_ARE_OFFLINE: 'Since you are offline, some parts of the application might be unavailable until you connect again.',
  TERMS_AND_CONDITIONS: 'Terms and conditions',
  HELP: 'Help',
  BACK_TO_LIBRARY: 'Back to library',
  BACK_TO_THE_BOOK: 'Back to book',
  MY_NOTEBOOK: 'My notebook',
  TABLE_OF_CONTENTS: 'Table of contents',
  FAVORITES: 'Favorites',
  HIGHLIGHTS: 'Highlights',
  HIGHLIGHTS_NO_CONTENT: 'You have not added any highlights in this book yet.',
  NOTES: 'Notes',
  NEWEST: 'Newest',
  WORDBANK: 'Wordbank',
  SEARCH_IN_BOOK: 'Search in book',
  SEARCH_PLACEHOLDER: 'What are you looking for?',
  SEARCH_RESULT_COUNT: 'results for search',
  SEARCH_EMPTY_TEXT: 'Your search field is empty.',
  SEARCH_NO_RESULTS: 'No results found',
  SEARCH_OFFLINE_HEADING: 'You\'re offline',
  SEARCH_OFFLINE: 'Sorry, but search feature is not available in offline. Connect to the internet and try again.',
  SEARCH_LOADING: 'Searching...',
  SEARCH_NO_RESULTS_TEXT: 'Sorry, but we couldn’t find any results for {phrase} in this book. Please try with different key word or phrase.',
  SETTINGS: 'Settings',
  SIZE_ASC: 'Size ascending',
  SIZE_DESC: 'Size descending',
  SLIDER_PREVIOUS: 'Previous',
  SLIDER_NEXT: 'Next',
  PRINT: 'Print',
  DOWNLOAD: 'Download',
  TOC_NO_CONTENT: 'This book doesn’t have table of contents.',
  SHOW_NAVIGATION: 'Show navigation',
  HIDE_NAVIGATION: 'Hide navigation',
  FAVORITES_NO_CONTENT: 'No favourites here',
  FAVORITES_NOT_ADDED: 'You have not added any favorites in this book yet.',
  ACTUAL_SIZE: 'Actual size',
  FIT_TO_SCREEN: 'Fit to screen',
  ZOOM_IN: 'Zoom in',
  ZOOM_OUT: 'Zoom out',
  ZOOM_CHANGE: 'Change zoom',
  ZOOM_FIT_TO_SCREEN: 'Fit to height',
  ANNOTATOR_HIGHLIGHT: 'Highlight',
  ANNOTATOR_ADD_NOTE: 'Add note',
  ANNOTATOR_WORDBANK: 'Wordbank',
  ANNOTATOR_LOOK_UP: 'Look up',
  LOOKUP_TITLE: 'Dictionary',
  LOOKUP_NO_CONTENT: 'Sorry, we could not find a translation from for this text.',
  NOTES_NO_CONTENT: 'No notes here',
  NOTES_NOT_ADDED: 'You have not added any notes in this book yet.',
  DBOK_READER: 'd-bok Reader',
  DBOK_FILE: 'd-bok-data',
  LIBRARY: 'Library',
  SELECT_TO_ARCHIVE: 'Select to remove from device',
  ARCHIVE: 'Remove from device',
  CANCEL: 'Cancel',
  SAVE: 'Save',
  PROCESSING: 'Processing...',
  DELETING: 'Deleting...',
  DELETE: 'Delete',
  PAGES_PER_VIEW: 'Pages per view',
  EDIT_NOTE: 'Edit note',
  NEW_NOTE: 'New note',
  ONE_PAGE: 'One page',
  TWO_PAGES: 'Two pages',
  PAGE: 'Page',
  GO_TO: 'Go to',
  PAGES_OUT_OF_TOTAL: 'of {0}',
  AT: 'at',
  NEXT_PAGE: 'Next page',
  PREVIOUS_PAGE: 'Previous page',
  ADD_TO_FAVORITES: 'Add this page to favorites',
  REMOVE_FROM_FAVORITES: 'Remove this page from favorites',
  HIDE_THUMBNAILS: 'Hide thumbnails',
  EXPAND_THUMBNAILS: 'Expand thumbnails',
  PAGE_NUMBER: 'Page number',
  CLOSE_MESSAGE: 'Close this message',
  NEXT_THUMBNAILS_ROW: 'Next row of book pages thumbnails',
  CLOSE_MENU: 'Close menu',
  CLEAR_INPUT: 'Clear input',
  FOCUS_INPUT: 'Focus search input',
  NOTE: 'Note',
  HIGHLIGHT: 'Highlight',
  TOGGLE_SUBCHAPTERS: 'Toggle subchapters',
  SEARCH_RESULT: 'Search result',
  IS_AVAILABLE_ONLINE: 'is available online',
  IS_AVAILABLE_OFFLINE: 'is available offline',
  SWITCH_TO_OLD_DBOK: 'Switch to old d-bok',
  BASE_FORM: 'Base form',
  WORD_CLASS: 'Word class',
  FORM: 'Form',
  FROM: 'From',
  TO: 'To',
  INFLECTION: 'Inflection',
  VIEW_DETAILS: 'View details',
  HIDE_DETAILS: 'Hide details',
  LISTEN_TO_PHRASE: 'Listen to phrase pronunciation',
  SYNONYMS: 'Synonyms',
  LOGIN_WELCOME_HEADING: 'Welcome to New d-bok!',
  LOGIN_WELCOME_PARAGRAPH: 'New d-bok is a complete new program for reading d-books from Fagbokforlaget.',
  LOGIN_WELCOME_LIST1: 'read d-books in the browser without access to Internet',
  LOGIN_WELCOME_LIST2: 'new technology and a brand new design',
  LOGIN_WELCOME_INFO1: 'Since this is a beta version there is some functionality that is not ready yet.',
  LOGIN_WELCOME_INFO2: 'Read more at <a target="_blank" href="https://www.fagbokforlaget.no/d-bok">https://www.fagbokforlaget.no/d-bok</a> (in Norwegian).',
  ALTERNATIVE_SPELLINGS: 'Alternative spellings',
  LOOKUP_LOADING: 'Looking up...',
  FEEDBACK_TITLE: 'Please Give Us Feedback',
  FEEDBACK_TEXT: 'We would like to hear from you! How can we improve our d-books?',
  FEEDBACK_YOUR_EMAIL: 'E-mail:',
  FEEDBACK_SUBMIT: 'Submit',
  FEEDBACK_CLOSE: 'Close',
  FEEDBACK_THANK_YOU: 'Thank you for your feedback!',
  FEEDBACK_FAILED: 'An error occured while submiting the form.',
  FEEDBACK_TEXT_REQUIRED: 'Write your feedback here.',
  FEEDBACK_EMAIL_REQUIRED: 'E-mail is required.',
  FEEDBACK_EMAIL_INVALID: 'Please enter a valid e-mail address.'
}

export default en
